import { render } from "./CheckoutSummary.vue?vue&type=template&id=fc3eb974"
import script from "./CheckoutSummary.vue?vue&type=script&lang=js"
export * from "./CheckoutSummary.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__